import React from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { Spin, Result, Button } from 'antd';
import { GroupProvider, useGroup } from './GroupContext';

const InnerProtected = ({ children }) => {
  const { allowed, loading, needsConsent, requestConsent } = useGroup();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (needsConsent) {
    return (
      <Result
        status="403"
        title="Oops, Access Not Granted"
        subTitle="We're sorry, it seems you don't have permission to use this application. Please contact George Hernandez to gain access."
      />
    );
  }

  if (!allowed) {
    return (
      <Result
        status="403"
        title="Oops, Access Not Granted"
        subTitle="We're sorry, it seems you don't have permission to use this application. Please contact George Hernandez to gain access."
      />
    );
  }

  return <>{children}</>;
};

const ProtectedRoute = ({ children }) => {
  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <GroupProvider>
        <InnerProtected>{children}</InnerProtected>
      </GroupProvider>
    </MsalAuthenticationTemplate>
  );
};

export default ProtectedRoute;